module.exports = __webpack_public_path__ + "static/media/features-top-image.a0e732ae.png";